module.exports = __webpack_public_path__ + "media/images/nevyzvednute-c4e72bac347adf22bf9a5a80718ab65f.png";